import { ciUnsavedChangesGuard } from './_components/ci/services/ci-unsaved-changes.guard';
import { Routes } from '@angular/router';
import { LoginComponent } from './auth/login/login.component';
import { SignupComponent } from './auth/signup/signup.component';
import { PagenotfoundComponent } from './wildcard/pagenotfound/pagenotfound.component';
import { DashboardComponent } from './_components/dashboard/dashboard.component';
import { authGuard } from './_helpers/auth.guard';
import { HeaderComponent } from './theme/header/header.component';
import { UsersComponent } from './_components/users/users.component';
import { PropertyComponent } from './_components/properties/property/property.component';
import { PropertiesComponent } from './_components/properties/properties.component';
import { DetailsComponent } from './_components/properties/details/details.component';
import { ImageUploadComponent } from './_components/properties/image-upload/image-upload.component';
import { AdvisorComponent } from './_components/advisor/advisor.component';
import { AddAdvisorComponent } from './_components/advisor/add-advisor/add-advisor.component';
import { ProfileComponent } from './_components/advisor/profile/profile.component';
import { RequestsComponent } from './_components/properties/requests/requests.component';
import { BasicComponent } from './_components/users/basic/basic.component';
import { UserInfoComponent } from './_components/users/user-info/user-info.component';
import { PremiumComponent } from './_components/users/premium/premium.component';
import { accessGuard } from './_helpers/access.guard';
import { UnauthorizedComponent } from './wildcard/unauthorized/unauthorized.component';
import { PropertyValuesComponent } from './_components/properties/property-values/property-values.component';
import { SliderProprtiesComponent } from './_components/dashboard/slider-proprties/slider-proprties.component';
import { AdminProfileComponent } from './_components/admin-profile/admin-profile.component';
import { SuperAdminComponent } from './_components/super-admin/super-admin.component';
import { CipDashboardComponent } from './_components/cip-dashboard/cip-dashboard.component';
import { CiNewPageComponent } from './_components/ci/ci-new-page.component';
import { ciQuestionsResolver } from './_components/ci/services/ci-questions.resolver';

export const routes: Routes = [
  // Open routes
  { path: '', component: LoginComponent },
  { path: 'signup', component: SignupComponent },

  // Protected routes
  {
    path: 'admin',
    canActivate: [authGuard], // Ensures user is logged in
    component: HeaderComponent,
    children: [
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
      {
        path: 'dashboard',
        component: DashboardComponent,
        data: { breadcrumb: 'Dashboard', roles: ['super_admin', 'admin'] },
      },
      {
        path: 'carousel',
        canActivate: [accessGuard],
        component: SliderProprtiesComponent,
        data: { breadcrumb: 'Carousel', roles: ['super_admin', 'admin'] },
      },
      {
        path: 'super-admin',
        canActivate: [accessGuard],
        component: SuperAdminComponent,
        data: { breadcrumb: 'Super Admin Access', roles: ['super_admin'] },
      },
      {
        path: 'admin-profile',
        canActivate: [accessGuard],
        component: AdminProfileComponent,
        data: { breadcrumb: 'Admin Profile', roles: ['super_admin', 'admin', 'property_manager', 'sales_advisor'] },
      },
      {
        path: 'admin-profile',
        canActivate: [accessGuard],
        component: AdminProfileComponent,
        data: { breadcrumb: 'Admin Profile', roles: ['super_admin', 'admin', 'property_manager', 'sales_advisor'] },
      },
      {
        path: 'users',
        canActivate: [accessGuard],
        data: { roles: ['super_admin', 'admin','sales_advisor'] },
        children: [
          {
            path: '',
            component: BasicComponent,
            data: { breadcrumb: 'Users' },
          },
          {
            path: 'basic',
            component: UsersComponent,
            data: { breadcrumb: 'Basic User' },
          },
          {
            path: 'premium',
            component: PremiumComponent,
            data: { breadcrumb: 'Premium User' },
          },
          {
            path: 'user-info',
            component: UserInfoComponent,
            data: { breadcrumb: 'User Info' },
          },
        ],
      },

      // PROPERTY: Super Admin, Admin, & Sales Advisor
      {
        path: 'property',
        canActivate: [accessGuard],
        data: { roles: ['super_admin', 'admin', 'sales_advisor','property_manager'] },
        children: [
          {
            path: '',
            component: PropertiesComponent,
            canActivate: [accessGuard],
            data: {roles: ['super_admin', 'sales_advisor','admin','property_manager'], breadcrumb: 'Property' },
          },
          {
            path: 'cip',
            component: CipDashboardComponent,
            canActivate: [accessGuard],
            title: 'CircledPlus Property Intelligence',
            data: {roles: ['super_admin','admin','property_manager'], breadcrumb: 'CircledPlus Property Intelligence' },
          },
          {
            path: 'ci-new',
            component: CiNewPageComponent,
            canDeactivate: [ciUnsavedChangesGuard],
            canActivate: [accessGuard],
            resolve: { questions: ciQuestionsResolver },
            title: 'CircledPlus Property Intelligence',
            data: {roles: ['super_admin','admin','property_manager'], breadcrumb: 'CircledPlus Property Intelligence' },
          },
          {
            path: 'add',
            component: PropertyComponent,
            canActivate: [accessGuard],
            data: {roles: ['super_admin','admin','property_manager'], breadcrumb: 'Add Property' },
          },
          {
            path: 'edit/:id',
            component: PropertyComponent,
            canActivate: [accessGuard],
            data: {roles: ['super_admin','admin','property_manager'], breadcrumb: 'Edit Property' },
          },
          {
            path: 'details',
            component: DetailsComponent,
            data: { breadcrumb: 'Details Property' },
          },
          {
            path: 'values',
            component: PropertyValuesComponent,
            data: { breadcrumb: 'Property Values' },
          },
          {
            path: 'requests',
            component: RequestsComponent,
            canActivate: [accessGuard],
            data: { roles: ['super_admin','admin','property_manager'], breadcrumb: 'Property Request' },
          },
          { path: 'image-upload/:id', component: ImageUploadComponent },
        ],
      },

      // ADVISOR: Super Admin & Admin Only
      {
        path: 'advisor',
        canActivate: [accessGuard],
        data: { roles: ['super_admin', 'admin'] },
        children: [
          { path: '', component: AdvisorComponent },
          { path: 'onboarding', component: AddAdvisorComponent },
          { path: 'edit', component: AddAdvisorComponent, data: { breadcrumb: 'Edit Advisor' }},
          { path: 'profile/:name/:id', component: ProfileComponent, data: { breadcrumb: 'Advisor Profile' }},
        ],
      },

      { path: '404', component: PagenotfoundComponent },
      { path: '**', redirectTo: '404' },
    ],
  },

  { path: 'unauthorized', component: UnauthorizedComponent }, // Add an unauthorized page
  { path: '404', component: PagenotfoundComponent },
  { path: '**', redirectTo: '404' },
];
